import React, { useEffect, useState } from 'react';
import { Badge, CircularProgress, Divider, Typography } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faBell, faTimes } from '@fortawesome/free-solid-svg-icons';
import { NavLink } from 'react-router-dom';
import { getUserNotifications } from '../../actions/Auth';
import { useDispatch } from 'react-redux';

import logo from '../../assets/img/logo_msv_horizontal.png';

import {
  Container,
  Logo,
  TitleIntranet,
  StyledAppBar,
  StyledIconButton,
  StyledToolbar,
  Desktop,
  Mobile,
  StyledNavLink,
  NotificationsPopover,
  NotificationsTitle,
  NotificationArea,
  InitialsIcon,
} from './style';
import { useSelector } from 'react-redux';
import { GET_NOTIFICATIONS } from '../../actions/types';

const Header = ({ setOpenSideMenu, openSideMenu }) => {
  const dispatch = useDispatch();

  const { notifications, colleagueid } = useSelector(({ auth }) => ({
    notifications: auth?.notifications || [],
    colleagueid: auth?.userData?.colleagueid || '',
  }));

  const [anchorEl, setAnchorEl] = useState(null);
  const [notLoading, setNotLoading] = useState(false);

  useEffect(() => {
    loadNotifications();

  }, []);


  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const loadNotifications = async () => {
    try {
      setNotLoading(true);
      const notifications = await getUserNotifications(colleagueid);
      
      await dispatch({
        type: GET_NOTIFICATIONS,
        payload: [...notifications],
      });

      setNotLoading(false);
    } catch (error) {
      setNotLoading(false);
      dispatch({
        type: GET_NOTIFICATIONS,
        payload: [],
      });

    }
  };


  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : '';

  return (
    <>
      <Desktop>
        <StyledAppBar>
          <StyledToolbar>
            <NavLink to="/home" style={{ display: 'flex', textDecoration: 'none', width: '100%' }}>
              <Logo alt="logo" src={logo} />
            </NavLink>
            <Container>
              <div>
                <TitleIntranet variant="h4">Intranet</TitleIntranet>
              </div>
              <StyledIconButton onClick={!notLoading ? handleClick : () => console.log('Carregando...')}>
                {notLoading ? (
                  <CircularProgress color="primary" />
                ) : (
                  <Badge badgeContent={notifications?.length ? notifications?.filter(item => item != null).length || '0' : '0'} color="primary">
                    <FontAwesomeIcon icon={faBell} />
                  </Badge>
                )}
              </StyledIconButton>
              <NotificationsPopover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
              >
                <NotificationsTitle variant="h5">Notificações</NotificationsTitle>
                <Divider style={{ marginBottom: '10px' }} />
                <div style={{ maxHeight: '400px', overflow: 'auto', marginBottom: '10px' }}>
                  {notifications?.length ? (
                    notifications?.filter(item => item != null)?.map((n, index) => {
                      return (
                        <NotificationArea key={index} onClick={() => window.open(n.documentUrl, '_blank').focus()}>
                          <InitialsIcon className="initials">!</InitialsIcon>
                          <Typography>{n?.processDescription}</Typography>
                        </NotificationArea>
                      );
                    })
                  ) : (
                    <div>Sem notificações</div>
                  )}
                </div>
              </NotificationsPopover>
            </Container>
          </StyledToolbar>
        </StyledAppBar>
      </Desktop>
      <Mobile>
        <StyledAppBar>
          <StyledToolbar>
            <StyledIconButton onClick={() => setOpenSideMenu(!openSideMenu)}>
              <FontAwesomeIcon icon={!openSideMenu ? faBars : faTimes} />
            </StyledIconButton>
            <StyledNavLink to="/home" style={{ display: 'flex', textDecoration: 'none' }}>
              <Logo alt="logo" src={logo} />
            </StyledNavLink>
            <StyledIconButton onClick={handleClick}>
              <FontAwesomeIcon icon={faBell} />
            </StyledIconButton>
          </StyledToolbar>
        </StyledAppBar>
      </Mobile>
    </>
  );
};

export default Header;
